import React, { useMemo, useEffect, useState } from 'react'
import { useTable, useSortBy, useGlobalFilter, useFilters, usePagination } from 'react-table'
import { COLUMNS } from './columns'
import { GlobalFilter } from './GlobalFilter'
import { Button, Badge, } from 'reactstrap';

import './table.css'

export const Shipping = () => {
    //   const [apiData, setApiData] = useState()
    const columns = useMemo(() => COLUMNS, [])
    //const data = useMemo(() => apiData, [apiData])
    // const [data, setData] = useState(apiData)
    const [data, setData] = useState([]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        //footerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        setPageSize,
        prepareRow,
        state,
        setGlobalFilter,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                hiddenColumns: ["shipmentId"],
                pageSize: 20
            }, 
           // autoResetSortBy: false,
            autoResetPage: false
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    )

    const { globalFilter, pageIndex, pageSize } = state
    const getShipmentData = async () => {
        try {
            const response = await fetch(
                "/api/shipment/List/",
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            //setApiData(payload);
            setData(payload)
            //console.log(payload)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getShipmentData();
    }, [])

    const cancelClickHandler = async (id) => {
        try {
            console.log(id)
            const response = await fetch(
                `/API/shipment/cancel/${id}`,
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            if (response.ok) {
                alert("Absagen erfolgt. Es dauert einige Sekunden, bis das Ergebnis angezeigt wird")
                getShipmentData()
            }
            if (!response.ok) {
                alert("unsuccessful cancelation");
            }
        } catch (e) {
            console.log(e);
            alert(e);
        }
    };

    const cancelPickUpClickHandler = async (id) => {
        try {
            console.log(id)
            const response = await fetch(
                `/API/shipment/pickup/cancel/${id}`,
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            if (response.ok) {
                alert("Absagen erfolgt. Es dauert einige Sekunden, bis das Ergebnis angezeigt wird")
                getShipmentData()
            }
            if (!response.ok) {
                alert("unsuccessful cancelation");
            }
        } catch (e) {
            console.log(e);
            alert(e);
        }
    };

    return (
        <div className='shippingTable'>
            <div className='shippingListHeader'>
                <Badge><h3>Sende- und Empfangsliste</h3></Badge>
                <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
                <select className="form-control" style={{ width: 'unset' }} value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                    {
                        [10, 15, 20, 25, 50, 'All'].map((pageSize) => (
                            <option key={pageSize} value={pageSize === 'All' ? 10000 : pageSize}>
                                Show {pageSize}
                            </option>
                        ))
                    }
                </select>
            </div>
            <div style={{overflowX:'auto'}}>
            <table style={{ maxWidth: '1408px' }} {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                                <th key={index}>
                                    <div className='d-block border-0' {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render('Header')}
                                    <span >
                                        {column.isSorted
                                            ? column.isSortedDesc
                                                ? ' 🔽'
                                                : ' 🔼'
                                            : ' ▶️'}
                                    </span>

                                    </div>
                                    <div className="d-flex">
                                        {column.canFilter ? column.render('Filter') : null}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                     console.log(cell)
                                    return (
                                        <td {...cell.getCellProps()}>
                                            {(cell.column.Header === "Tracking No." && cell.row.original.isCanceled === false) ? <i className="fas fa-window-close customIcon" onClick={() => { console.log(cell.row.values.shipmentId, cell.row.original.isCanceled); cancelClickHandler(cell.row.values.shipmentId) }}></i> :
                                                (cell.column.Header === "Pickup No." && cell.row.original.pickupCanceled === false) ? <i className="fas fa-window-close customIcon" onClick={() => { console.log(cell.row.original.pickupId, cell.row.original.pickupCanceled); cancelPickUpClickHandler(cell.row.original.pickupId) }}></i> : ''}
                                            {(cell.column.Header === "Tracking No." && cell.row.original.isCanceled === true) ? <del>{cell.render('Cell')}</del> : (cell.column.Header === "Pickup No." && cell.row.original.pickupCanceled === true) ? <del>{cell.render('Cell')}</del> : cell.render('Cell')}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            </div>
            <div className='pageOptions' style={{ marginLeft: 'auto', marginRight: 'auto', display: 'table' }}>
                <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                    {'<<'}
                </Button>
                <Button onClick={() => previousPage()} disabled={!canPreviousPage}>Previous</Button>
                <span>
                    Page{' '}
                    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                    </strong>{' '}
                </span>
                <Button onClick={() => nextPage()} disabled={!canNextPage}>Next</Button>
                <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                    {'>>'}
                </Button>
            </div>
        </div>
    )
}